import { colorFormatted } from 'common/libs/getColors'
import { Dark, Light } from './pallete'

/**
 *
 * @returns {EdisaTheme}
 */
const getPalette = () => {
  const storedTheme = localStorage.getItem('theme') || 'light'

  const pallete = storedTheme === 'light' ? Light : Dark
  return pallete
}

/**
 * @type {EdisaTheme}
 */
const palette = getPalette()

/**
 *
 * @type {import('@mui/material').Components<Omit<import('@mui/material').Theme, "components">>}
 */

export const get_components_styles = (palette) => {
  return {
    MuiPopover: {
      styleOverrides: {
        root: {
          '&.headerNotificationBox,&.headerLaboralNotificationBox': {
            '& .MuiPaper-root': {
              backgroundColor: colorFormatted(palette, 'background.warning'),
              '& .MuiButton-text': {
                backgroundColor: '#00000000',
              },
            },
          },
          '&.avisosNotificationBox': {
            '& .MuiPaper-root': {
              boxShadow: 'var(--Paper-shadow)',
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          '& #solicitud-label-component': {
            pl: 2,
          },
          boxShadow: 'none',
          '&.MuiPaper-rounded': {
            borderRadius: '30px',
          },
          '&.inicio': {
            borderRadius: '30px',
            '@media (min-width: 960px)': {
              padding: '100px',
              width: '100%',
            },
            '@media (max-width: 960px)': {
              marginTop: '65px',
              padding: '100px 25px 100px 25px',
            },
          },
          '&.menu': {
            // overflowY: 'auto',
            '@media (min-width: 960px)': {
              borderRadius: '0 30px 0 0',
            },
          },
          '&.content-paper': {
            borderRadius: '30px',
            padding: '40px',
            fontWeight: 300,
          },
          '&.degradado': {
            backgroundColor: colorFormatted(palette, 'primary.main'),
            backgroundImage:
              'linear-gradient(140deg, var(--mui-palette-LinearProgress-primaryBg), var(--mui-palette-LinearProgress-secondaryBg))',
            width: '100%',
          },
          '&.naranjita': {
            backgroundColor: colorFormatted(palette, 'background.warning'),
          },
          '&.titSolicitud': {
            boxShadow: 'none',
            fontWeight: '300',
            verticalAlign: 'baseline',
          },
          '&.docs': {
            borderRadius: '40px',
            color: 'primary.constrastText',
          },
          '&.MuiPopover-paper': {
            backgroundColor: colorFormatted(palette, 'background.paper'),
            color: colorFormatted(palette, 'text.primary'),
            borderRadius: '40px',
            padding: '10px',
            '& .MuiStack-root': {
              '& .MuiBox-root': {
                backgroundColor: colorFormatted(palette, 'background.default'),
                color: '#142D5F',
                borderRadius: '15px',
                paddingLeft: '5px',
                '& .MuiSvgIcon-root': {},
              },
            },
          },
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          '@media (max-width: 960px)': {
            borderRadius: '0 0 30px 0',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          color: colorFormatted(palette, 'primary.main'),
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          color: colorFormatted(palette, 'text.primary'),
          '& .MuiInputBase-root': {
            fontWeight: '400',
            color: colorFormatted(palette, 'text.primary'),
            padding: '2px',
            backgroundColor: colorFormatted(palette, 'background.default'),
            zIndex: 0,
            minHeight: '48px',
            height: 'auto',
            borderRadius: '15px',
            borderBottom: 'none',
            boxShadow: 'none',
            '&::before': {
              display: 'none',
            },
            '&::after': {
              display: 'none',
            },
            '& input.MuiInputBase-input': {
              padding: '10px 10px',
            },
            '& .MuiOutlinedInput-root': { p: 1 },
            '& input.MuiOutlinedInput-input': {
              borderRadius: '15px',
              borderColor: colorFormatted(palette, 'primary.main'),
              boxSizing: 'border-box',
            },
            '& input:autofill; & input:-webkit-autofill': {
              backgroundColor: colorFormatted(palette, 'background.paper'),
            },
            '& textarea': {
              height: 'auto !important',
              padding: '10px',
            },
          },
          '& .MuiFormLabel-root': {
            zIndex: 2,
            fontSize: '0.9rem',
            fontWeight: '300',
            marginTop: '0px',
            marginLeft: '0px',
            mr: 1,
            color: colorFormatted(palette, 'text.primary'),
          },
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'text' },
          style: {
            backgroundColor: colorFormatted(palette, 'background.paper'),
            paddingLeft: '18px',
            paddingRight: '18px',
          },
        },
      ],
      styleOverrides: {
        root: {
          boxShadow: 'none',
          '&.MuiButton-text': {},
          borderRadius: '1000px',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          '&.bold': {
            fontWeight: '500',
          },
          '&.lighter': {
            fontWeight: '300',
          },
          '&.blue': {
            color: colorFormatted(palette, 'secondary.main'),
          },
        },
      },
    },

    MuiGrid: {
      styleOverrides: {
        root: {
          '& .MuiDataGrid-columnHeaders': {},
          '&.botonClaro': {
            backgroundColor: colorFormatted(palette, 'background.paper'),
          },
          '& .map': {
            borderRadius: '30px',
          },
          '&.mapContainer': {
            flexDirection: 'row-reverse',
            flexWrap: 'wrap',
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          color: colorFormatted(palette, 'primary.main'),
          borderRadius: '10px',
          boxShadow: 'none',
          '&:before': {
            backgroundColor: 'unset',
          },
          '& .MuiAccordionSummary-root': {
            '& .MuiTypography-body1': {
              fontSize: '1.1rem',
              fontWeight: '450',
            },
            '& .MuiTypography-body2': {
              fontWeight: '350',
              fontSize: '0.775rem',
            },
          },
          '& .MuiAccordionDetails-root': {
            '& .MuiTypography-body1': {
              fontSize: '0.875rem',
              fontWeight: '400',
            },
          },
        },
      },
    },
    MuiStack: {
      styleOverrides: {
        root: {
          verticalAlign: 'baseline',
          '&.solicitudes': {
            display: 'flex',
            '@media (min-width: 960px)': {
              flexDirection: 'row',
            },
            '@media (max-width: 960px)': {
              flexDirection: 'column',
            },
            flexWrap: 'wrap',
            width: '100%',
            gap: '10px',
            '& .MuiCard-root': {
              marginTop: 0,
              '@media (min-width: 960px)': {
                flex: '0 0 calc(25% - 7.5px)',
              },
              '@media (max-width: 960px)': {
                flex: '0 0 100%',
              },
              height: '115px',
              maxWidht: '25%',
              boxSizing: 'border-box',
              boxShadow: 'none',
              '& .MuiButtonBase-root': {
                borderRadius: '30px',
                height: '105px',
                '& .MuiCardContent-root': {
                  marginLeft: '60px',
                  widht: '250px',
                  overflow: 'hidden',
                },
                '& .MuiTypography-root': {
                  fontSize: '1rem',
                  fontWeight: '410',
                },
                '& .MuiTypography-body2': {
                  display: 'none',
                },
              },
            },
          },
          '& .outline-paper': {
            '& .MuiPaper-root': {
              backgroundColor: 'transparent',
              '& .MuiCardHeader-action': {
                color: colorFormatted(palette, 'primary.main'),
              },
              '& .MuiCardContent-root': {
                border: '4px solid ' + colorFormatted(palette, 'background.paper'),
                borderRadius: '30px',
                '& .MuiList-root': {
                  backgroundColor: 'transparent',
                  '& .MuiListItem-root': {
                    backgroundColor: colorFormatted(palette, 'background.paper'),
                    borderRadius: '10px',
                    marginBottom: '8px',
                    minHeight: '56px',
                    '& .MuiListItemText-root': {
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      '& span': {
                        fontSize: '1rem',
                        lineHeight: '1.5',
                      },
                      '& p': {
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        lineHeight: '1.5',
                      },
                    },
                  },
                  '& .MuiListItem-root:last-child': {
                    marginBottom: '0px',
                  },
                },
              },
              '& .MuiCardContent-root:last-child': {
                paddingBottom: '16px',
              },
            },
            '& .emergencia': {
              '& .MuiCardHeader-root': {
                color: colorFormatted(palette, 'error.main'),
              },
              '& .MuiCardContent-root': {
                backgroundColor: colorFormatted(palette, 'error.main'),
                border: 'none',
                color: '#fff',
                '& .MuiList-root': {
                  '& .MuiListItem-root': {
                    backgroundColor: colorFormatted(palette, 'background.default'),
                    color: colorFormatted(palette, 'error.main'),
                    borderRadius: '10px',
                    marginBottom: '8px',
                    minHeight: '56px',
                  },
                },
              },
            },
          },
          '&.header-actions': {
            '& .library-icon': {
              '@media (min-width: 960px)': {
                color: colorFormatted(palette, 'primary.main'),
              },
              '@media (max-width: 960px)': {
                color: colorFormatted(palette, 'primary.contrastText'),
              },
              '& path': {
                '@media (min-width: 960px)': {
                  fill: colorFormatted(palette, 'primary.main'),
                },
                '@media (max-width: 960px)': {
                  fill: colorFormatted(palette, 'primary.contrastText'),
                },
              },
            },
          },
        },
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          '&.MuiBottomNavigationAction-root': {
            color: colorFormatted(palette, 'primary.main'),
          },
          '& .MuiFab-circular': {
            backgroundColor: colorFormatted(palette, 'background.alternative'),
            color: '#ffff',
            boxShadow: 'none',
            '&.SpeedDialbasicexample-actions': {},
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '30px',
          '& .MuiTypography-body1': {
            fontSize: '0.8rem',
          },
          '&.perfil': {
            backgroundColor: colorFormatted(palette, 'background.primary80'),
            borderRadius: '40px',
            color: '#fff',
            '& .MuiFormLabel-root': {
              marginTop: '10px',
              padding: '5px',
              fontWeight: '500',
              color: '#9096AA',
            },
            '& .MuiCardActions-root': {
              '& .MuiSelected': {
                color: colorFormatted(palette, 'secondary.main'),
              },
            },
          },
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          marginRight: '8px',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          '& .MuiPaper-root': {
            boxShadow:
              '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
            borderRadius: '15px',
          },
        },
      },
    },
    MuiPickerPopper: {
      styleOverrides: {
        paper: {
          boxShadow:
            '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
          borderRadius: '15px',
        },
      },
    },
  }
}

const components_styles = get_components_styles(palette)

export default components_styles
